var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"dense":"","items":_vm.items,"label":"Theme"},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }